// The legal/financial "who is selling this?" entity (see doc/sweden-expansion-currency-plan.md).
// Mirrors backendservices/domain/TenantCompany.cs.
import ObjectIdGenerator from '../modules/objectidgenerator';

class TenantCompany {
    constructor(json) {
        if (json) {
            this.clusterId = json.clusterId;
            this.id = json.id;
            this.name = json.name;
            // ISO3166-1 numeric country code (same convention as Address.country), e.g. 246 = Finland --
            // not a "FI"/"SE" alpha code.
            this.countryCode = json.countryCode;
            this.currency = json.currency;
            this.vatRate = json.vatRate;
            this.orgNumber = json.orgNumber;
            this.vatId = json.vatId;
            this.accountingIntegration = json.accountingIntegration;
            // Prefix shown in front of the order number on this tenant's orders (e.g. "SE"). Only affects
            // orders sent after saving -- see doc/sweden-expansion-order-number-prefix-plan.md.
            this.orderNumberPrefix = json.orderNumberPrefix;
        } else {
            this.clusterId = 0;
            this.id = 0;
            this.name = '';
            this.countryCode = null;
            this.currency = '';
            this.vatRate = 0;
            this.orgNumber = '';
            this.vatId = null;
            this.accountingIntegration = null;
            this.orderNumberPrefix = null;
        }
    }

    static NewObject() {
        return ObjectIdGenerator.newId().then((id) => new TenantCompany({ id }));
    }
}

export default TenantCompany;
